import React from "react";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	MainHeaderButtonsWrapper: {
		display: "flex",
		alignItems: "center",
		flex: "0 1 auto",
		flexWrap: "wrap",
		gap: theme.spacing(1),
		marginLeft: "auto",
		"& > *": {
			margin: 0,
		},
		"@media (max-width: 600px)": {
			width: "100%",
			marginLeft: 0,
			justifyContent: "flex-start",
		},
	},
}));

const MainHeaderButtonsWrapper = ({ children }) => {
	const classes = useStyles();

	return <div className={classes.MainHeaderButtonsWrapper}>{children}</div>;
};

export default MainHeaderButtonsWrapper;
